import { CombinedState, PayloadAction, combineReducers, configureStore } from "@reduxjs/toolkit";
import { TypedUseSelectorHook, useDispatch, useSelector } from "react-redux";
import storage from 'redux-persist/lib/storage';
import { persistReducer, persistStore} from 'redux-persist';

import authorizationReducer from "./reducers/authorizationSlice";
import organizationReducer from "./reducers/organizationSlice";
import storeReducer from "./reducers/storeSlice";
import cabinetReducer from "./reducers/cabinetSlice";
import brandReducer from "./reducers/brandSlice";

const appReducer = combineReducers({
  authorization: authorizationReducer,
  organization: organizationReducer,
  store: storeReducer,
  cabinet: cabinetReducer,
  brand: brandReducer,
  // add reducers
});

export const RESET_ACTION = {
  type: 'USER_LOGOUT'
};

const rootReducer = (state: CombinedState<any>, action: PayloadAction) => {
  return action.type === 'USER_LOGOUT' 
    ? appReducer(undefined, action) 
    : appReducer(state, action);
};

// redux persist
const persistConfig = {
  key: 'root',
  storage,
};

const persistedReducer = persistReducer(persistConfig, rootReducer);

const store = configureStore({
  reducer: persistedReducer
});


type RootState = ReturnType<typeof store.getState>;
type AddDispatch = typeof store.dispatch;

export const useAppSelector: TypedUseSelectorHook<RootState> = useSelector;
export const useAppDispatch = () => useDispatch<AddDispatch>();

export const persistor = persistStore(store);
export default store;
